import { render, staticRenderFns } from "./RideitNoticesTableItem.vue?vue&type=template&id=ff500f08&scoped=true"
import script from "./RideitNoticesTableItem.vue?vue&type=script&lang=ts"
export * from "./RideitNoticesTableItem.vue?vue&type=script&lang=ts"
import style0 from "./RideitNoticesTableItem.vue?vue&type=style&index=0&id=ff500f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff500f08",
  null
  
)

export default component.exports